import trackPhotoStockSearchClicked from './photo-stock-search-clicked';
import trackPhotoStockSearchPerformed from './photo-stock-search-performed';

export default {
  trackPhotoStockSearchClicked,
  trackPhotoStockSearchPerformed,
};
